
export interface ProductMenuItem {
  label: string
  href?: string
  children?: ProductMenuItem[]
}

export interface ProductMenuGroup {
  label: string
  items: ProductMenuItem[]
}

export const PRODUCTS_HREF = '/category-template'
const categoryHref = '/category-template'

export const PRODUCT_GROUPS: ProductMenuGroup[] = [
  { label: 'Milling', items: [
    { label: 'End Mills', href: categoryHref, children: ['Square End Mills', 'Ball End Mills', 'Corner Radius End Mills', 'High Performance End Mills', 'End Mills For Aluminum', 'Micro End Mills', 'Roughing End Mills', 'Chamfer Mills', 'Drill Mills', 'Straight Flute End Mills'].map(label => ({ label, href: categoryHref })) },
    { label: 'Carbide End Mills', href: categoryHref },
    { label: 'Carbide Burrs', href: categoryHref, children: ['SA Cylindrical', 'SB Cylindrical End Cut', 'SC Cylindrical Ball Nose', 'SD Ball Shape', 'SE Egg Shape', 'SF Round Nose Tree', 'SG Pointed Tree', 'SH Flame Shape'].map(label => ({ label, href: categoryHref })) },
    { label: 'Routers', href: categoryHref }, { label: 'Keyseat Cutters', href: categoryHref }, { label: 'Slitting Saws', href: categoryHref },
  ] },
  { label: 'Hole Making', items: [
    { label: 'Drill Bits', href: categoryHref, children: ['Carbide Drill Bits', 'Cobalt Drill Bits', 'HSS Drill Bits'].map(label => ({ label, href: categoryHref })) },
    { label: 'Reamers', href: categoryHref }, { label: 'Countersinks', href: categoryHref },
  ] },
  { label: 'Thread Making', items: [{ label: 'Thread Mills', href: categoryHref }, { label: 'Taps', href: categoryHref }, { label: 'Dies', href: categoryHref }] },
  { label: 'Metal Working Fluids', items: [
    { label: 'Machining Coolants', href: categoryHref, children: ['Semi-Synthetic', 'Synthetic'].map(label => ({ label, href: categoryHref })) },
    { label: 'Rust Inhibitors', href: categoryHref },
  ] },
  { label: 'Brands', items: [{ label: 'Titan USA', href: categoryHref }, { label: 'Harvey Tool', href: categoryHref }, { label: 'M A Ford', href: categoryHref }] },
]

